module.exports = __webpack_public_path__ + "img/icon_dtfl_by_1.7f24583c.png";